import React from 'react';

import { Checkbox, CheckboxGroup } from 'carbon-react/lib/components/checkbox';
import Box from 'carbon-react/lib/components/box';

import { SelectFilterFieldConfig } from '../types';

interface SelectFilterFieldProps {
  config: SelectFilterFieldConfig;
  onChange: (key: string, optionValue: string, checked: boolean) => void;
}

/**
 * Component for rendering a select filter field in the filters sidebar, allowing users to select multiple options using checkboxes
 * @param config - The configuration for the select filter field
 * @param onChange - Function to call when an option is selected or deselected
 * @returns A JSX element representing the select filter field
 */
export const SelectFilterField = ({ config, onChange }: SelectFilterFieldProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(config.key, event.target.value, event.target.checked);
  };

  return (
    <Box mb={3}>
      <CheckboxGroup legend={config.label}>
        {config.options.map(option => (
          <Checkbox
            key={option.value}
            label={option.text}
            value={option.value}
            checked={config.selectedValues[option.value] ?? false}
            onChange={handleChange}
          />
        ))}
      </CheckboxGroup>
    </Box>
  );
};
